import { colors } from 'theme/colors';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const StyledLicenceWrapper = styled(Grid)`
  background-color: ${colors.gray100};
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  padding: 20px 20px 20px 32px;
  margin-bottom: 16px;
  row-gap: 12px;
  column-spacing: 12px;
`;
